import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight, Facebook, Instagram } from 'lucide-react';
import { Logo } from './Logo';
import { useLang } from '@/i18n/LangContext';
import { Link } from 'wouter';

export function Footer() {
  const { tr } = useLang();

  return (
    <footer className="py-32 px-6 relative overflow-hidden border-t border-border/50 bg-background">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_left,_var(--tw-gradient-stops))] from-primary/15 via-background to-background -z-10"></div>
      <div className="max-w-4xl mx-auto text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <h2 className="text-5xl md:text-7xl font-extrabold mb-8 tracking-tight text-white">
            {tr.footer.ctaTitle}{" "}
            <br />
            <span className="text-primary">{tr.footer.ctaTitleExtra}</span>
          </h2>
          <p className="text-xl text-muted-foreground mb-12 max-w-2xl mx-auto font-light">
            {tr.footer.ctaDesc}
          </p>
          <Link
            href="/contacto"
            className="inline-flex items-center justify-center whitespace-nowrap rounded-full h-16 px-10 text-lg font-bold bg-primary text-primary-foreground hover:bg-primary/90 hover:scale-105 transition-all duration-300 shadow-[0_0_30px_rgba(56,189,248,0.2)]"
          >
            {tr.footer.startConversation}
            <ArrowUpRight className="ml-2 w-6 h-6" />
          </Link>
        </motion.div>
      </div>

      <div className="max-w-7xl mx-auto mt-40 pt-8 border-t border-border flex flex-col md:flex-row items-center justify-between gap-6 relative z-10">
        <Logo />

        <div className="flex items-center gap-4">
          <a
            href="https://www.facebook.com/mediaexperto"
            target="_blank"
            rel="noopener noreferrer"
            className="w-10 h-10 rounded-full bg-[#1877F2] flex items-center justify-center text-white hover:opacity-85 transition-opacity"
            aria-label="Facebook"
          >
            <Facebook className="w-4 h-4" />
          </a>
          <a
            href="https://www.instagram.com/media_experto"
            target="_blank"
            rel="noopener noreferrer"
            className="w-10 h-10 rounded-full flex items-center justify-center text-white hover:opacity-85 transition-opacity"
            style={{ background: "linear-gradient(135deg, #f58529, #dd2a7b, #515bd4)" }}
            aria-label="Instagram"
          >
            <Instagram className="w-4 h-4" />
          </a>
          <a
            href="https://wa.me/18097091552"
            target="_blank"
            rel="noopener noreferrer"
            className="w-10 h-10 rounded-full bg-[#25D366] flex items-center justify-center text-white hover:opacity-85 transition-opacity"
            aria-label="WhatsApp"
          >
            <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
            </svg>
          </a>
        </div>

        <p className="text-sm text-muted-foreground font-mono">
          © {new Date().getFullYear()} Media Experto. {tr.footer.rights}
        </p>
      </div>
    </footer>
  );
}
